export default __webpack_public_path__ + "static/insta4@2x-d0c7a973dc9e1e76f49b551b57d6a05f.jpg";